import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export function IntegrationHero(t0) {
  const $ = _c(31);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    flush: t2,
    title: t3,
    description: t4
  } = t1;
  const flush = t2 === undefined ? false : t2;
  const title = t3 === undefined ? "Integrations" : t3;
  const description = t4 === undefined ? "Explore integrations, trigger events, and automate actions to power your workflows." : t4;
  const t5 = flush ? "" : "max-w-[1440px] px-0 md:px-[9px]";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("relative mx-auto w-full", t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = flush ? "py-0" : "py-[15px]";
  let t8;
  if ($[4] !== t7) {
    t8 = cn("relative flex items-center justify-center", t7);
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = flush ? "" : "mx-2 sm:mx-4 md:mx-8";
  let t10;
  if ($[6] !== t9) {
    t10 = cn("rounded-ds-xl border-ds-border bg-ds-surface-card shadow-ds-soft md:rounded-ds-2xl relative w-full border p-[10px]", t9);
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== title) {
    t11 = <MobileHeader title={title} />;
    $[8] = title;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== title) {
    t12 = <div className="hidden md:contents"><HeaderFrame title={title} /></div>;
    $[10] = title;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== description) {
    t13 = <p className="text-ds-text-subtle relative z-[3] mt-[20px] max-w-[475px] px-4 text-center text-lg leading-7 md:mt-[24px]">{description}</p>;
    $[12] = description;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="from-ds-surface-primary pointer-events-none absolute inset-y-0 left-0 w-[116px] bg-gradient-to-r via-white/80 to-transparent dark:via-zinc-950/80" />;
    t15 = <div className="from-ds-surface-primary pointer-events-none absolute inset-y-0 right-0 w-[116px] bg-gradient-to-l via-white/80 to-transparent dark:via-zinc-950/80" />;
    t16 = <div className="from-ds-surface-primary pointer-events-none absolute inset-x-0 top-0 h-[32px] bg-gradient-to-b to-transparent" />;
    t17 = <div className="from-ds-surface-primary pointer-events-none absolute inset-x-0 bottom-0 h-[32px] bg-gradient-to-t to-transparent" />;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t13) {
    t18 = <div className="rounded-ds-md bg-ds-surface-primary md:rounded-ds-14 relative flex h-[220px] flex-col items-center overflow-hidden pt-[24px] md:h-[256px] md:pt-[32px]">{t11}{t12}{t13}{t14}{t15}{t16}{t17}</div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t10 || $[23] !== t18) {
    t19 = <div className={t10}>{t18}</div>;
    $[22] = t10;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t19 || $[26] !== t8) {
    t20 = <div className={t8}>{t19}</div>;
    $[25] = t19;
    $[26] = t8;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t20 || $[29] !== t6) {
    t21 = <div className={t6}>{t20}</div>;
    $[28] = t20;
    $[29] = t6;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  return t21;
}
function MobileHeader(t0) {
  const $ = _c(4);
  const {
    title
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-ds-border-default pointer-events-none absolute left-1/2 top-0 h-px w-screen -translate-x-1/2" />;
    t2 = <div className="bg-ds-border-default pointer-events-none absolute bottom-0 left-1/2 h-px w-screen -translate-x-1/2" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <div className="relative z-[3] flex h-[88px] items-center justify-center px-6 md:hidden">{t1}{t2}<div className="border-ds-border bg-ds-surface-card shadow-ds-elev-mid relative flex h-[72px] items-center justify-center rounded-full border px-8"><span aria-hidden="true" className="text-ds-text-subtle leading-label text-3xl font-medium tracking-[-0.56px] sm:text-4xl">{title}</span></div></div>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
const LEFT_CONNECTOR_X = [20, 70, 120, 170, 220];
const RIGHT_CONNECTOR_X = [707, 757, 807, 857, 907];
function HeaderFrame(t0) {
  const $ = _c(25);
  const {
    title
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-ds-border-default pointer-events-none absolute inset-y-0 left-0 w-px" />;
    t2 = <div className="bg-ds-border-default pointer-events-none absolute inset-y-0 right-0 w-px" />;
    t3 = <div className="bg-ds-border-default pointer-events-none absolute left-1/2 top-1/2 h-px w-[1200px] -translate-x-1/2 -translate-y-1/2" />;
    t4 = <img aria-hidden={true} src="/images/integrations-hero/wire.svg" alt="" className="pointer-events-none absolute left-[-221px] top-[-20px] z-[1] h-[160px] w-[302px] dark:opacity-20" />;
    t5 = <img aria-hidden={true} src="/images/integrations-hero/wire.svg" alt="" className="pointer-events-none absolute right-[-221px] top-[-20px] z-[1] h-[160px] w-[302px] -scale-x-100 dark:opacity-20" />;
    t6 = LEFT_CONNECTOR_X.map(_temp);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-ds-border-default pointer-events-none absolute left-1/2 top-0 h-px w-[1200px] -translate-x-1/2" />;
    t8 = <div className="bg-ds-border-default pointer-events-none absolute bottom-0 left-1/2 h-px w-[1200px] -translate-x-1/2" />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-ds-surface-primary pointer-events-none absolute left-[-3.5px] top-1/2 h-[7px] w-[7px] -translate-y-1/2 rounded-full"><div className="bg-ds-text-disabled absolute left-1/2 top-1/2 h-[3px] w-[3px] -translate-x-1/2 -translate-y-1/2 rounded-full" /></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="bg-ds-surface-primary pointer-events-none absolute right-[-3.5px] top-1/2 h-[7px] w-[7px] -translate-y-1/2 rounded-full"><div className="bg-ds-text-disabled absolute left-1/2 top-1/2 h-[3px] w-[3px] -translate-x-1/2 -translate-y-1/2 rounded-full" /></div>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== title) {
    t11 = <div className="border-ds-border bg-ds-surface-card shadow-ds-elev-lg flex h-[100px] w-[389px] items-center justify-center rounded-full border"><p aria-hidden="true" className="text-ds-text-subtle leading-label text-5xl font-medium tracking-[-0.96px]">{title}</p></div>;
    $[10] = title;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="rounded-ds-1 bg-ds-border-default pointer-events-none absolute -left-[3px] -top-[3px] h-[6px] w-[6px]" />;
    t13 = <div className="rounded-ds-1 bg-ds-border-default pointer-events-none absolute -right-[3px] -top-[3px] h-[6px] w-[6px]" />;
    t14 = <div className="rounded-ds-1 bg-ds-border-default pointer-events-none absolute -bottom-[3px] -left-[3px] h-[6px] w-[6px]" />;
    t15 = <div className="rounded-ds-1 bg-ds-border-default pointer-events-none absolute -bottom-[3px] -right-[3px] h-[6px] w-[6px]" />;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t11) {
    t16 = <div className="absolute left-[270px] top-0 z-[3] flex h-[120px] w-[409px] items-center justify-center">{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[16] = t11;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = RIGHT_CONNECTOR_X.map(_temp2);
    t18 = <CornerSquare className="-left-[7px] -top-[7px]" />;
    t19 = <CornerSquare className="-right-[7px] -top-[7px]" />;
    t20 = <CornerSquare className="-bottom-[7px] -left-[7px]" />;
    t21 = <CornerSquare className="-bottom-[7px] -right-[7px]" />;
    $[18] = t17;
    $[19] = t18;
    $[20] = t19;
    $[21] = t20;
    $[22] = t21;
  } else {
    t17 = $[18];
    t18 = $[19];
    t19 = $[20];
    t20 = $[21];
    t21 = $[22];
  }
  let t22;
  if ($[23] !== t16) {
    t22 = <div className="relative flex h-[120px] w-[949px] max-w-full shrink-0 items-center justify-center">{t1}{t2}{t3}{t4}{t5}{t6}{t16}{t17}{t18}{t19}{t20}{t21}</div>;
    $[23] = t16;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  return t22;
}
function _temp2(x_0) {
  return <Connector key={`r-${x_0}`} x={x_0} />;
}
function _temp(x) {
  return <Connector key={`l-${x}`} x={x} />;
}
function Connector(t0) {
  const $ = _c(2);
  const {
    x
  } = t0;
  const t1 = `${x}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = <img aria-hidden={true} src="/images/integrations-hero/connector.svg" alt="" className="pointer-events-none absolute z-[2] h-[83px] w-[22px] dark:opacity-20" style={{
      left: t1,
      top: "18.5px"
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function CornerSquare(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("border-ds-border-default bg-ds-surface-primary pointer-events-none absolute z-[4] h-[14px] w-[14px] border", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div aria-hidden={true} className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}